"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionBodyRegistryWidget = exports.AccordionBodyWidget = void 0;
var Expander_1 = require("ContentTokens/SharedWidgetComponents/Expander");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var PlaceholderContext_1 = __importDefault(require("Project/QwilrEditor/Placeholder/PlaceholderContext"));
var react_1 = __importStar(require("react"));
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var AccordionContext_1 = require("./AccordionContext");
var AccordionBodyWidgetComponent = (function (_super) {
    __extends(AccordionBodyWidgetComponent, _super);
    function AccordionBodyWidgetComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionBodyWidgetComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, attributes = _a.attributes, expanded = _a.context.expanded, widgetAdderStore = _a.widgetAdderStore, children = _a.children;
        return (react_1.default.createElement("div", __assign({}, attributes),
            react_1.default.createElement(Expander_1.Expander, { open: expanded, onExpanded: widgetAdderStore.triggerForceReposition, onCollapsed: widgetAdderStore.triggerForceReposition },
                react_1.default.createElement("div", { className: "accordion-widget-body", "data-layout-node": "true" },
                    react_1.default.createElement(PlaceholderContext_1.default, { placeholders: {
                            paragraph: function (element) {
                                var pathOfElement = slate_react_1.ReactEditor.findPath(_this.editor, element);
                                var parentNode = slate_1.Node.parent(_this.editor, pathOfElement);
                                var isOnlyChild = parentNode.children.length === 1;
                                var selectionInAccordionBody = false;
                                if (_this.editor.selection && attributes.ref.current) {
                                    var accordionBodyNode = slate_react_1.ReactEditor.toSlateNode(_this.editor, attributes.ref.current);
                                    var accordionBodyPath = slate_react_1.ReactEditor.findPath(_this.editor, accordionBodyNode);
                                    var selectionPath = _this.editor.selection.anchor.path;
                                    selectionInAccordionBody = slate_1.Path.isAncestor(accordionBodyPath, selectionPath);
                                }
                                if (isOnlyChild && !selectionInAccordionBody) {
                                    return "Add content";
                                }
                                else {
                                    return;
                                }
                            },
                        } }, children)))));
    };
    var _a;
    __decorate([
        (0, inversify_react_1.resolve)(EditorTypes_1.SlateEditor.$),
        __metadata("design:type", typeof (_a = typeof EditorTypes_1.SlateEditor !== "undefined" && EditorTypes_1.SlateEditor) === "function" ? _a : Object)
    ], AccordionBodyWidgetComponent.prototype, "editor", void 0);
    AccordionBodyWidgetComponent = __decorate([
        mobx_react_1.observer
    ], AccordionBodyWidgetComponent);
    return AccordionBodyWidgetComponent;
}(react_1.default.Component));
exports.AccordionBodyWidget = (0, AccordionContext_1.withAccordionContext)(AccordionBodyWidgetComponent);
var AccordionBodyRegistryWidget = function (_a) {
    var children = _a.children;
    var widgetAdderStore = (0, inversify_react_1.useInjection)("widgetAdderStore");
    var accordionBodyRef = (0, react_1.useRef)(undefined);
    return (react_1.default.createElement(exports.AccordionBodyWidget, { attributes: { ref: accordionBodyRef }, widgetAdderStore: widgetAdderStore, isSelected: false }, children));
};
exports.AccordionBodyRegistryWidget = AccordionBodyRegistryWidget;
